import {
  Box,
  Loader,
  Center,
  Divider,
  Flex,
  Grid,
  Paper,
  Text,
  Title,
  createStyles,
} from "@mantine/core";

import CustomBreadcrumbs from "../../components/CustomBreadCrumbs";
import calendarSvg from "../../assets/img/calendar.svg";
import activeLogo from "../../assets/img/active.svg";

import { Summary } from "./Summary";
import { ServiceDetails } from "./ServiceDetails";
import { useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import { useNavigate } from "react-router-dom";
import {
  MedicalSummary,
  codingSystemMap,
  generateHPBCSummary,
  getCoverageResponse,
  getPatientName,
  mapServiceDetails,
} from "./EligibiltyService";
import { getPatient } from "../../utils";
import { formatAddress } from "./EligibiltyService";
import { ServiceTag } from "./ServiceTag";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",

    padding: "16px",
    marginTop: "16px",
  },
  breadCrumbs: {
    marginBottom: "28px",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }, 
  Box1: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  loader: {
    marginTop: "40px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  title1: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  cancel: {
    color: "black",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  create: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  descrption: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    marginBottom: "5px",
  },
  textarea: {
    height: "168px",
    width: "100%",
    padding: "16px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "22px",
    border: "1px solid #E5E5E5",
    outline: "none",
    resize: "none",
    borderRadius: "8px",
    wordBreak: "break-word",
  },
  textHeading: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "21px",
    color: "#474E5B",
  },
  textdata: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#262930",
    paddingTop: "6px",
  },
  dataBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  RequestId: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    paddingRight: "20px",
  },
  headingBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

export const EligibilityDetails = () => {
  const { classes } = useStyles();
  const rightsection = (
    <img
      src={calendarSvg}
      style={{
        width: 15,
        height: 15,
        color: "#666",
        cursor: "pointer",
      }}
    />
  );

  const medplum = useMedplum();
  const navigate = useNavigate();

  const [cResponse, setCResponse] = useState<any>(null);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [patient, setPatient] = useState<any>(null);
  const [cResId, setCResId] = useState<any>(null);
  const [tileDataArray, setTileDataArray] = useState<any>([]);
  const [serviceDetails, setServiceDetails] = useState<any>([]);
  const [dataExtensions, setdataExtensions] = useState<any>([]);

  useEffect(() => {
    // get id from url
    const location = window.location.href;
    const url = new URL(location);
    const id = url.searchParams.get("id");
    if (!id) {
      navigate("/admin/insurance/eligibility");
      return;
    }
    getCoverageResponse(medplum, id).then((res: any) => {
      setCResponse(res);
      setCResId(res?.identifier.find((id: any) => [codingSystemMap['pverify'], codingSystemMap['availity']].includes(id.system)))
      formatPatient(res);

      const sDetails = mapServiceDetails(res?.insurance);
      setServiceDetails(sDetails);
      const tileArray = generateHPBCSummary(res?.extension);
      setTileDataArray(tileArray);
      const dataExtension = MedicalSummary(res?.extension);
      setdataExtensions(dataExtension);
      setIsFetching(false);
    });
  }, []);

  const formatPatient = (cResponse: any) => {
    const pDetails = { ...cResponse.patientDetails };
    pDetails.isSelfVerification = getVerification();
    setPatient(pDetails);
  };

  const getVerification = () => {
    if (
      cResponse?.coverage?.subscriber &&
      cResponse?.coverage?.subscriber !== cResponse?.patient
    ) {
      return false;
    } else {
      return true;
    }
  };

  const Patientdetails = [
    {
      title: "Patient Name",
      data: `${getPatientName(patient?.name)}`,
    },
    //add conditional object for subscriber
    ...(cResponse?.related
      ? [
          {
            title: "Related",
            data: `${getPatientName(cResponse?.related?.name)}`,
          },
          {
            title: "Relationship",
            data: `${
              cResponse?.related?.relationship?.[0].coding[0].display ?? "--"
            }`,
          },
        ]
      : []),

    {
      title: "Address",
      data: patient?.address[0]?.line[0] ?? "--",
    },
    {
      title: "City-State-Zip",
      data: formatAddress(patient?.address[0]),
    },
    {
      title: "Gender",
      data: patient?.gender.charAt(0).toUpperCase() + patient?.gender.slice(1),
    },
    {
      title: "Date Of Birth",
      data: patient?.birthDate?.replaceAll("-", "/") ?? "--",
    },
  ];

  const PlanDetails = [
    {
      title: "Plan Name",
      data: cResponse?.coverage?.class[0]?.name ?? "--",
    },
    {
      title: "Plan Number",
      data: cResponse?.coverage?.class[0]?.value ?? "--",
    },
    {
      title: "Policy Type",
      data: cResponse?.coverage?.class[0]?.type?.text ?? "--",
    },

    // {
    //   title: "Eligibility Begin",
    //   data: "01/01/2017",
    // },
  ];

  const eligibilityDetails = [
    {
      title: "Status",
      data: cResponse?.status.toUpperCase(),
    },
    {
      title: "Payer",
      data: cResponse?.insurer?.name,
    },
    {
      title: "Verification type",
      data: cResponse?.related ? "Dependent Verification" : "Self Verification",
    },
    {
      title: "Eligibility Period",
      data: `${cResponse?.planSummary?.EffectiveDate ?? "--"}  to ${
        cResponse?.planSummary?.ExpirationDate ?? "--"
      }`,
    },

    {
      title: "Date of Service",
      data: `${new Date(
        cResponse?.servicedPeriod?.start
      ).toLocaleDateString()} - ${new Date(
        cResponse?.servicedPeriod?.end
      ).toLocaleDateString()}`,
    },
  ];

  return (
    <>
      {isFetching ? (
        <Center className={classes.loader}>
          <Loader />
        </Center>
      ) : (
        <Paper className={classes.default}>
          <Box sx={{}}>
            <Box className={classes.Box1}>
              <Box className={classes.breadCrumbs}>
                <CustomBreadcrumbs />
                <ServiceTag serviceType={cResId?.system?.includes('pverify') ? 'pverify' : 'availity'} />
              </Box>
              <Box className={classes.headingBox} >
                <Title className={classes.title1}>Eligibility details</Title>
                <Title className={classes.RequestId}>
                  Request Id :{" "}
                  {cResId?.value}
                </Title>
              </Box>
              <Box>
                <Flex sx={{ width: "100%" }}>
                  <Grid grow sx={{ width: "100%" }}>
                    {eligibilityDetails.map((data, index) => (
                      <Grid.Col span={4}>
                        <Flex
                          bg={"#F1F9FF"}
                          direction={"column"}
                          sx={{
                            height: "90px",
                            border:
                              data.title === "Status" && data.data === "ACTIVE"
                                ? "1px solid #2C9D08"
                                : "none",
                            backgroundColor:
                              data.title === "Status" && data.data === "ACTIVE"
                                ? "#efffef"
                                : "#F1F9FF",
                            borderRadius: "4px",
                          }}
                          justify={"space-evenly"}
                        >
                          <Text
                            align={"center"}
                            size={14}
                            weight={500}
                            color={"#474E5B"}
                          >
                            {data.title}
                          </Text>
                          <Box className={classes.dataBox}>
                            {" "}
                            {data.title === "Status" &&
                              data.data === "ACTIVE" && (
                                <img
                                  src={activeLogo}
                                  alt="check"
                                  style={{ paddingRight: "5px", width: "20px" }}
                                />
                              )}
                            <Text
                              size={14}
                              weight={700}
                              color={
                                data.title === "Status" &&
                                data.data === "ACTIVE"
                                  ? "#2C9D08"
                                  : "#262930"
                              }
                            >
                              {" "}
                              {data.data}
                            </Text>
                          </Box>
                        </Flex>
                      </Grid.Col>
                    ))}
                  </Grid>
                </Flex>
                <Box pt={"24px"}>
                  <Divider />
                </Box>
              </Box>
              <Box>
                <Text weight={700} size={18} color="#262930">
                  Patient Details
                </Text>
              </Box>
              <Box>
                <Grid
                  columns={12}
                  sx={{
                    border: "1px solid #BEDEF8",
                    padding: "15px",
                    borderRadius: "5px",
                  }}
                >
                  {Patientdetails.map((data, index) => (
                    <Grid.Col span={2} key={index}>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Text className={classes.textHeading}>
                          {data.title}
                        </Text>

                        <Text className={classes.textdata}>{data.data}</Text>
                      </Box>
                    </Grid.Col>
                  ))}
                </Grid>
                <Box pt={"24px"}></Box>
              </Box>

              <Box>
                <Text weight={700} size={18} color="#262930">
                  Plan Details
                </Text>
              </Box>
              <Box>
                <Grid
                  columns={12}
                  sx={{
                    border: "1px solid #BEDEF8",
                    padding: "15px",
                    borderRadius: "5px",
                  }}
                >
                  {PlanDetails.map((data, index) => (
                    <Grid.Col span={2} key={index}>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Text className={classes.textHeading}>
                          {data.title}
                        </Text>

                        <Text className={classes.textdata}>{data.data}</Text>
                      </Box>
                    </Grid.Col>
                  ))}
                </Grid>
                <Box pt={"24px"}>
                  <Divider />
                </Box>
              </Box>
              {dataExtensions && (
                <>
                  {" "}
                  <Box>
                    <Text weight={700} size={18} color="#262930">
                      Medicare Info Summary
                    </Text>
                    <Text weight={600} size={16} color="#262930" pt={18}>
                      Medicare Co-insurance
                    </Text>
                  </Box>
                  <Box>
                    <Grid columns={24} mb={30}>
                      <Grid.Col span={12}>
                        <Summary
                          sideTitle1="Part A"
                          sideTitle2="Part B"
                          title={"Medical Care Deductible"}
                          colName={["Annual", "Remaining"]}
                          inNetworkCoINS={
                            dataExtensions.Part_B_Deductible_Remaining?.Value ??
                            "--"
                          }
                          inNetworkCopay={
                            dataExtensions.Part_A_Deductible?.Value ?? "--"
                          }
                          outNetworkCoINS={
                            dataExtensions.Part_B_Deductible_Remaining?.Value ??
                            "--"
                          }
                          outNetworkCopay={
                            dataExtensions.Part_B_Deductible?.Value ?? "--"
                          }
                        />
                      </Grid.Col>
                      <Grid.Col span={12}>
                        <Summary
                          sideTitle1="OT"
                          sideTitle2="PT-SLP"
                          title={"Medical Care Services"}
                          colName={["Maximum", "Used"]}
                          inNetworkCoINS={dataExtensions.OT_CapAmount?.Value}
                          inNetworkCopay={dataExtensions.OT_UsedAmount?.Value}
                          outNetworkCoINS={
                            dataExtensions.PT_SLP_CapAmount?.Value
                          }
                          outNetworkCopay={
                            dataExtensions.PT_SLP_UsedAmount?.Value
                          }
                        />
                      </Grid.Col>
                    </Grid>
                    {dataExtensions?.dataSections.map(
                      (section: any, index: any) => {
                        return (
                          <Box
                            sx={{
                              display: "flex",
                              border: "1px solid #BEDEF8",
                              borderRadius: "5px",
                              padding: "15px",
                            }}
                            mt={16}
                          >
                            <Grid columns={24} sx={{ width: "100%" }}>
                              {Object.entries(section.data).map(
                                (item: any, index) => (
                                  <Grid.Col span={6}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                      }}
                                    >
                                      <Text
                                        sx={{
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "#474E5B",
                                        }}
                                      >
                                        {item[0]}
                                      </Text>
                                      <Text
                                        sx={{
                                          fontWeight: 600,
                                          fontSize: "14px",
                                          color: "#262930",
                                        }}
                                      >
                                        {item[1]}
                                      </Text>
                                    </Box>
                                  </Grid.Col>
                                )
                              )}
                            </Grid>
                          </Box>
                        );
                      }
                    )}

                    <Box pt={"24px"}>
                      <Divider />
                    </Box>
                  </Box>
                </>
              )}

              <Box>
                <Text weight={700} size={18} color="#262930">
                  HBPC Summary
                </Text>
              </Box>
              <Box>
                <Grid columns={24}>
                  {tileDataArray.map((data: any, index: number) => (
                    <Grid.Col span={12} key={index}>
                      <Summary
                        sideTitle1="In-Network"
                        sideTitle2="                Out-Network
"
                        title={data?.title}
                        colName={data?.colName}
                        inNetworkCoINS={data?.inNetworkCoINS}
                        inNetworkCopay={data?.inNetworkCopay}
                        outNetworkCoINS={data.outNetworkCoINS}
                        outNetworkCopay={data?.outNetworkCopay}
                      />
                    </Grid.Col>
                  ))}
                </Grid>
                <Box pt={"24px"}>
                  <Divider />
                </Box>
              </Box>
              <Box>
                <Text weight={700} size={18} color="#262930">
                  Service Details
                </Text>
              </Box>
              <Box>
                <Grid columns={24}>
                  {serviceDetails.length > 0 &&
                    serviceDetails?.map((data: any, index: number) => (
                      <Grid.Col span={24}>
                        <ServiceDetails service={data} />
                      </Grid.Col>
                    ))}
                </Grid>
              </Box>
            </Box>
          </Box>
        </Paper>
      )}
    </>
  );
};
